<template>
  <div id="content" class="manage_default_data">
    <AddToGroupModal :dialogVisible='dialoglist'  @close="dialoglist = false"
     @toExisting="assignToExisting($event)"
     @toNew="assignToNew($event)"></AddToGroupModal>
    <div class="content_div">


    <h1>{{ $t("Users' criterias")}}</h1>

    <div class="selectedZone">
    <span class="titleSelectedZone">{{ $t("Selected criteria")}}</span>
    <div class="listOfSelectedCriteria">
      <div class="oneCriteriaSelected" v-for="(criteria,c) in selection_crit" :key="c">
        <v-img :src="require('@/assets/infoCriteriaBlanc.svg')" alt=""  @click="toggleDetailsSelected(c)"></v-img>
          <span class="criteriaName" >{{criteria.name}} </span>
          <CriteriaDetails v-click-outside="hideDetails" @pleaseEdit="pleaseEdit($event)" @pleaseDeleted="pleaseDeleted($event)" :criteria="criteria" :criteriaGroups="criteriaGroups" :forcenoedit="true" :hideGroup="true" v-if="showDetailsIndexInSelected === c"/>


      </div>
      <div class="" v-if="selection_crit.length == 0">
          Please select at least one criteria to set as public
      </div>
    </div>
    <div class="row tcenter" v-if='selection_crit.length > 0' >
      <button type="button" class="prev_step_btn_alt" name="button" @click="dialoglist = true">Make selection public</button>
    </div>
    </div>


    <div class="listOfSelectedCriteriaWrapper mt50">
        <span class="titleSelectedZone">{{ $t("Existing users")}}</span>
        <div class="groupsList">
          <div class="oneGroup" v-for='(group,g) in criteriaGroups' :key="g">
          <div class="oneGroupHead">
            <span class="groupTitle">{{group.firstname}} {{group.lastname}} - {{group.entreprise}}
            </span>


          </div>

          <div class="listOfAvailableCriteria">
            <div class="oneClassicCriteria" v-for='(criteria, c) in group.criteriaList' :key="c">

                <span class="criteriaName" @click="toggleDetailsAvailable(c,g)">{{criteria.name}}
                </span>
                 <button class="selectCriteria" @click="pushCrit(criteria)">
                  <v-img :src="require('@/assets/selectCriteriaBlack.svg')" alt=""></v-img>

                </button>
                <CriteriaDetails :forcenoedit="true" :hideGroup="true" @pleaseEdit="pleaseEdit($event)" v-click-outside="hideDetails" :criteria="criteria" :criteriaGroups="criteriaGroups"  v-if="showDetailsIndexInAvailable === c && showDetailsGroupIndexInAvailable  == g"/>

            </div>
        </div>
              </div>


        </div>


            </div>
                </div>
  </div>
</template>
<script>
import api from '@/tools/api';
import { mapState } from 'vuex';
// import router from '@/router'
import CriteriaDetails from '@/components/CriteriaDetail.vue'
 import AddToGroupModal from '@/components/modals/addToCriteriaGroup.vue'

 import { toast } from 'vue-sonner'
export default {
  components: {
    CriteriaDetails,
    AddToGroupModal
  },
  name: 'ManageAssessments',
  data() {
    return {
      pageInfo: {
        mainTitle : "Manage users' criterias",
        subTitle : "",
      },
      selection_crit: [],
      dialogUpdate:false,
      toupdate:null,
      showDetailsIndexInAvailable:null,
showDetailsGroupIndexInAvailable:null,
showDetailsIndexInSelected:null,
showDetailsIndexInFav:null,
      criteriaGroups: [],
      dialog:false,
      hideEmptyGroups:false,
      groupEdited:null,
      dialogUpdateGroup:false,
      dialoglist:false,
    }
  },
  methods:{
    assignToExisting(v){
      console.log("assignToExisting",v);
      api.post(process.env.VUE_APP_API_URL+"/restrict/criteria_global_duplication",
          {
              selection : this.selection_crit,
              groupId: v
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("Criteria(s) set as public");

            this.$router.push("/admin/manage_assessments_criterias");
        });
    },
    assignToNew(v){
      api.post(process.env.VUE_APP_API_URL+"/restrict/criteria_global_duplication",
          {
              selection : this.selection_crit,
              groupName: v
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("Criteria(s) set as public");

                this.$router.push("/admin/manage_assessments_criterias");
        });
    },
    pushCrit(criteria){
      if (!this.selection_crit.some(item => item._id.$oid == criteria._id.$oid)) {
        this.selection_crit.push(criteria);
      }
    },
    toggleDetailsSelected(index) {

      if (this.showDetailsIndexInSelected === index) {
        this.showDetailsIndexInSelected = null; // Hide if already visible
      } else {
        this.showDetailsIndexInSelected = index; // Show the clicked index
        this.showDetailsIndexInFav = null; // Hide if already visible
        this.showDetailsIndexInAvailable = null; // Hide if already visible
        this.showDetailsGroupIndexInAvailable = null;
      }
    },
    editGroupName(g){
      this.groupEdited = g;
      this.dialogUpdateGroup = true;
    },
    removeGroup(g){
      console.log(g);
      var confirmed = window.confirm("Are you sure you want to delete this item?");
      if (confirmed) {
        console.log(confirmed);
        var v = {
          _id : g._id.$oid,
        };
        api.post(process.env.VUE_APP_API_URL+"/restrict/remove_group",
            v,
            {
              headers: {
                  'Content-Type': 'application/json',
            }
          }).then( (r) => {
            toast.success("Group name successfully removed");
            console.log("remove ckx ,",r.data);
             this.criteriaEmptyGroups = r.data;
              this.$forceUpdate();

          }).catch( (e) => {
            console.log(e);
             toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      }
    },

    pleaseEdit(c){
        this.toupdate = c;
        this.dialogUpdate = true;
    },
    toggleDetailsAvailable(index,group) {
      if (this.showDetailsIndexInAvailable === index && this.showDetailsGroupIndexInAvailable == group) {
        this.showDetailsIndexInAvailable = null; // Hide if already visible
        this.showDetailsGroupIndexInAvailable = null;
      } else {
        this.showDetailsIndexInAvailable = index; // Show the clicked index
        this.showDetailsGroupIndexInAvailable = group;
      this.showDetailsIndexInFav = null; // Hide if already visible
      this.showDetailsIndexInSelected = null;
      }
    },
    hideDetails(){
      this.showDetailsIndexInFav = null; // Hide if already visible
      this.showDetailsIndexInSelected = null;
      this.showDetailsIndexInAvailable = null; // Hide if already visible

    },
    newCriteriaCreated(crit){
      if(crit){
        console.log("inserted crit",crit);
        api.get(process.env.VUE_APP_API_URL+"/restrict/list_ucriterias").then( (r) => {
          this.criteriaGroups = r.data;
          console.log("qsdfqsfd",this.data);
        }).catch( (e) => {
          console.log(e);
           toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });

      this.dialog = false;
      this.dialogUpdate = false;
    }
  }
  },
  mounted(){
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)
     api.get(process.env.VUE_APP_API_URL+"/restrict/list_ucriterias").then( (r) => {
       this.criteriaGroups = r.data;
       console.log("qsdfqsfd",this.data);
     }).catch( (e) => {
       console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });


  },
  computed: mapState(['uid']),

}
</script>
<style scoped>

.manage_default_data{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}


.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 50px;
  opacity: 1;
  padding: 7px 25px;
  color:#FFF;
  display:inline-block;
  font-size: 16px;
  text-transform: uppercase;
}
.mt50{
  margin-top:50px;
}
.mt20{
  margin-top:20px;
  margin-bottom: 20px;
}


  .listOfAvailableCriteria{
    display:flex;
    gap:20px;
    margin-top:20px;
    flex-wrap: wrap;
  }



  .listOfSelectedCriteria .oneCriteriaSelected{
    background:#3982C4;
    color:#FFF;
    padding:5px 20px;
    display:flex;
    gap:10px;
    border-radius: 50px;
    border: 1px solid #3982C4;
    position:relative;
  }

  .oneFavoriteCriteria{
    background:#3982C41A;
    color:#3982C4;
    padding:5px 20px;
    display:flex;
    gap:10px;
    border-radius: 50px;
    border: 1px solid #3982C41A;
    position:relative;
  }

  .oneClassicCriteria{
    background:#fff;
    color:#000;
    padding:5px 20px;
    display:flex;
    gap:10px;
    border-radius: 50px;
    border: 1px solid #000;
    position:relative;
    cursor:pointer;
  }
  .oneGroupHead{
    display:flex;
    gap:10px;
  }

  .groupTitle{
    font-weight:700;
    color:#3982C4;
    font-size:16px;
  }

  .groupsList{
    display:flex;
    flex-direction: column;
    gap:40px;
    margin-top:20px;
  }

  .titleSelectedZone{
    font-size:16px;
    font-weight: 700;
    color:#04246A;
  }

  .selectedZone{
    margin-top:50px;
  }
  .favoriteZone{
    margin-top:50px;
  }
  .allCriteriaZone{
    margin-top:20px;
  }

  .lineDivider{
    width:100%;
    height:2px;
    margin-top:50px;
    background:#E1E3E6;
  }
  .searchbox{
    margin-bottom:25px;
  }
  #criteriaSearch{
    border:1px solid #E1E3E6;
    padding:5px 15px;
    margin-top:5px;
    min-width: 300px;
  }


    .prev_step_btn{
      color:#3783C5;
      background: #fff 0% 0% no-repeat padding-box;
      border: 1px solid #3783C5;
      border-radius: 50px;
      opacity: 1;
        padding: 7px 20px;
      margin:0px;
      display:flex;
      gap:10px;
    }
    .prev_step_btn_alt{
      color:#3783C5;
      background: #fff 0% 0% no-repeat padding-box;
      border: 1px solid #3783C5;
      border-radius: 50px;
      opacity: 1;
        padding: 7px 20px;
      margin: auto;
  display: inline-block;
  width: auto;
    }

      .titleSelectedZone{
        font-size:16px;
        font-weight: 700;
        color:#04246A;
      }

      .selectedZone{
        margin-top:50px;
        padding: 30px;
      background: #EBF2F9;
      border-radius: 20px;
      display:flex;
      flex-direction: column;
      }
      .favoriteZone{
        margin-top:50px;
      }
      .allCriteriaZone{
        margin-top:20px;
      }


        .listOfAvailableCriteria,
        .listOfSelectedCriteria{
          display:flex;
          gap:20px;
          margin-top:20px;
          flex-wrap: wrap;
        }



        .listOfSelectedCriteria .oneCriteriaSelected{
          background:#3982C4;
          color:#FFF;
          padding:5px 20px;
          display:flex;
          gap:10px;
          border-radius: 200px;
          border: 1px solid #3982C4;
          position:relative;
        }
</style>
